import { render, staticRenderFns } from "./stockRemind.vue?vue&type=template&id=43a76e92&scoped=true&"
import script from "./stockRemind.vue?vue&type=script&lang=js&"
export * from "./stockRemind.vue?vue&type=script&lang=js&"
import style0 from "./stockRemind.vue?vue&type=style&index=0&id=43a76e92&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43a76e92",
  null
  
)

export default component.exports